export const PageTypeId = {
	PublicDocumentLogin: 28,
	PublicDocumentList: 29,
	Custom: 30,
	ConnectApiUserList: 31,
	ConnectApiUserDetails: 32,
	CaoWmlList: 35,
	CaoWmlDetails: 36,
	TimecardList: 37,
	CaoNewsList: 39,
	CaoNewsDetails: 40,
	EmployerList: 43,
	EmployerDetails: 44,
	EmployerSettings: 45,
	PayslipDetails: 46,
	IllnessList: 52,
	TimecardDetail: 54,
	LabelTemplates: 57,
	SubscriberList: 59,
	NewsList: 62,
	NewsDetails: 63,
	NewsAdminList: 64,
	NewsAdminDetails: 65,
	Home: 166,
	ManagementInformation: 72,
	CaoList: 75,
	ContractList: 76,
	ContractDetails: 77,
	DocumentList: 78,
	CaoInstanceList: 79,
	AgencyList: 80,
	AgencyDetails: 81,
	AgencySettings: 82,
	DocumentSettingsDetails: 83,
	CandidateList: 84,
	CandidateDetails: 85,
	CaoAllowancesDetails: 93,
	CaoCommonDetails: 96,
	CaoSurchargesDetails: 97,
	CaoInstanceCommonDetails: 98,
	UserList: 99,
	UserDetails: 100,
	ModelMatrixInstanceList: 102,
	ModelMatrixInstanceDetails: 103,
	SettingList: 104,
	UserProfile: 113,
	UserLogIn: 114,
	CaoWagesList: 119,
	UserCustomAccess: 120,
	CandidateReservationList: 134,
	CaoWagesRequestsList: 135,
	CaoWagesRequestsDetails: 136,
	CandidatePhaseList: 151,
	UserNewPassword: 163,
	Dashboard: 71,
	AgencyStructure: 170,
	CustomerSubscriptionSettingList: 176,
	CustomerSubscriptionSettingDetails: 177,
	EmployerContactPersonsList: 185,
	CustomerSubscriptionSettingAccess: 186,
	CandidateChangeList: 188,
	PublicJobApply: 189,
	PublicJobConfirmation: 190,
	JobList: 193,
	JobDetails: 194,
	PublicJobJobList: 195,
	LabelTemplateDetails: 196,
	PublicJobJobDetails: 197,
	PayslipList: 200,
	ConnectIncomingLogList: 202,
	ConnectOutgoingLogList: 206,
	RoleList: 208,
	RoleDetails: 209,
	RoleAccess: 211,
	ConnectIncomingList: 213,
	ConnectOutgoingList: 214,
	ConnectSettings: 215,
	ConnectIncomingDetails: 216,
	ConnectOutgoingDetails: 217,
	CustomerList: 225,
	AuditTrailList: 244,
	DocumentSettingsList: 268,
	FlexNetBundleList: 269,
	PaymentList: 270,
	InvoiceComponentsList: 273,
	ConnectDashboard: 277,
	NewsPublicNewsList: 281,
	NewsPublicNewsDetails: 282,
	CommunitiesList: 284,
	CommunitiesDetails: 285,
	FlexNetHostList: 297,
	RateClassesList: 298,
	RateClassesDetails: 300,
	FlexNetCustomerList: 301,
	FormPublic: 304,
	FormConfirmation: 305,
	ApplicationList: 308,
	ApplicationDetails: 309,
	DomainValuesList: 310,
	ApplicationForm: 311,
	ConnectFSApiLogList: 323,
	DomainValuesCAOMapping: 353,
	LabelTranslations: 354,
	ShareJobBoardConfiguration: 356,
	TagList: 357,
	DocumentTemplateList: 368,
	DocumentTemplateDetails: 369,
	ConnectEmailSenderAuthList: 370,
	ConnectEmailSenderAuthDetails: 371,
	DomainValuesMapping: 396,
	CommentList: 401,
	SurveyList: 402,
	CustomerCustomerDetails: 403,
	SurveyDetails: 404,
	SupportedBrowsers: 405,
	LabelList: 413,
	LabelLabelDetails: 414,
	FlexNetHostDetails: 420,
	FlexNetCustomerDetails: 421,
	FlexNetHostSettings: 422,
	SurveyListOptOutList: 425,
	IncommingCall: 439,
	ModelMatrixList: 445,
	ModelMatrixDetails: 446,
	SavedFilterOtherUsersFiltersList: 450,
	SavedFilterMyFiltersList: 451,
	SavedFilterSystemFiltersList: 452,
	SavedFilterAlertLogsList: 453,
	ShareJobBoardInstanceList: 459,
	ShareJobBoardList: 465,
	ShareJobBoardInstanceDetails: 470,
	PublicJobAllJobs: 477,
	ShareJobBoardDetails: 484,
	ComponentModelList: 486,
	TextModelList: 495,
	ComponentModelDetails: 497,
	TextModelDetails: 500,
	CustomerCustomerSettings: 505,
	ShareJobPostList: 506,
	ShareJobBoardInstanceConfiguration: 514,
	InvoiceList: 832,
	CandidateTermsAndConditionsForRegistration: 842,
	TaskList: 849,
	CustomerSubscriptionList: 855,
	CustomerSubscriptionDetails: 856,
	CustomerInvoiceList: 862,
	CustomerInvoiceDetails: 863,
	ShareJobPostDetails: 865,
	ActivityList: 866,
	SurveyAdminList: 871,
	SurveyAdminDetails: 872,
	ShareLogList: 878,
	ShareLogDetails: 879,
	PublicEmployerEmployerList: 882,
	PublicEmployerEmployerDetails: 883,
	CalculationSchemeList: 886,
	CalculationSchemeDetail: 889,
	LabelPagesList: 890,
	LabelPageDetails: 892,
	FormDesignerList: 896,
	FormDesignerDetails: 897,
	FormUserList: 898,
	EmployerContactpersonDetails: 900,
	PensionList: 902,
	FormPublicRegistration: 903,
	DealList: 904,
	DealDetails: 905,
	IllnessDetails: 906,
	CandidatePeriodicComponentsList: 907,
	CalculationSchemeClockwiseTest: 908,
	TranslationsDetails: 909,
	FormUserDetails: 910,
	ConnectCustomerAccessRequestList: 911,
	ProformaList: 913,
	ProformaDetail: 914,
	SupplierOrganizationList: 915,
	SupplierOrganizationDetails: 916,
	AutomationList: 917,
	AutomationDetails: 918,
	CustomCaoList: 920,
	CustomCaoCommonDetails: 921,
	AutomationLogList: 922,
	SafetyList: 923,
	CustomCaoInstanceList: 924,
	CustomCaoInstanceCommonDetails: 925,
	ContractBulkUpdateRequestList: 926,
	CandidateCandidateStatusMapping: 927,
	ContractBulkUpdateDetails: 928,
	DomainValuesDetails: 929,
	ConnectorList: 930,
	ConnectorDetails: 931,
	InvoicePurchaseInvoice: 932,
	BackofficeIndex: 933,
	BackofficeJournalTransferFilesList: 934,
	BackofficeProcessingList: 935,
	BackofficePaymentTransferFilesList: 936,
	Faq: 937,
	Help: 938,
	AboutUs: 939,
	CookiePolicy: 940,
	PrivacyStatement: 941,
	SecurityStatement: 942,
	TermsOfUse: 943,
	ContactUs: 944,
	CvdPolicy: 945,
} as const;
